export default class BranchModel {
    
    coords = {lat: 0, lng : 0}
    address             = ""
    addressSecondary    = ""
    imageUrl    = ""
    name       = ""
    nameSecondary = ""
    details     = ""
    phone = ""
    isHeader = true
    itemsList = []
    timings = []

    constructor(){
    }
}